/* eslint-disable no-restricted-globals */
import { HTTP_CODE, ERROR_HANDLING_EXPERIENCE } from '../../utils/redirector-utils';

export function isNotFound({ data, itemId }) {
  if (data && !data.product) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Item ${itemId} not found`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT
    };
  }

  return null;
}

export function isInvalidItemId({ itemId }) {
  if (!/^\d{8,10}$/.test(itemId)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Invalid item id ${itemId}`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT,
    };
  }

  return null;
}

export const isInvalidQuestionsCanonical = ({ data, path }) => {
  const { canonicalUrl } = data?.product?.identifiers || {};

  if (canonicalUrl) {
    const segments = path?.replace(/^\/|\/$/g, '').split('/');
    const pageNumber = segments?.length > 4 ? segments[segments.length - 1] : 1;
    const page = pageNumber && !isNaN(pageNumber) ? `/${pageNumber}` : '/1';

    const canonicalUrlWithContext = canonicalUrl?.replace('/p/', '/p/questions/').concat(page);

    if (path !== canonicalUrlWithContext && path !== encodeURI(canonicalUrlWithContext)) {
      return {
        shouldRedirect: true,
        httpCode: HTTP_CODE.PERM_REDIRECT,
        redirectPath: canonicalUrlWithContext,
        description: 'redirected for canonical'
      };
    }
  }

  return null;
};
